import type { PlayerData } from '@/types';

interface PlayerCurrencyProps {
  player: PlayerData;
}

export const PlayerCurrency = ({ player }: PlayerCurrencyProps) => {
  // Support both balance and currency structures
  const coins = player.balance?.coins || player.currency?.coins || 0;
  const tokens = player.balance?.tokens || 0;
  const gems = player.currency?.gems || 0;
  const points = player.currency?.points || 0;

  return (
    <div className="section">
      <div className="label">Monnaie en jeu</div>
      <div className="space-y-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <span className="text-lg">🪙</span>
            <span className="text-sm text-crisp-gray-dark">Pièces</span>
          </div>
          <span className="font-semibold text-base text-crisp-dark">
            {coins.toLocaleString('fr-FR')}
          </span>
        </div>
        {tokens > 0 && (
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <span className="text-lg">🎫</span>
              <span className="text-sm text-crisp-gray-dark">Tokens</span>
            </div>
            <span className="font-semibold text-base text-crisp-dark">
              {tokens.toLocaleString('fr-FR')}
            </span>
          </div>
        )}
        {gems > 0 && (
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <span className="text-lg">💎</span>
              <span className="text-sm text-crisp-gray-dark">Gemmes</span>
            </div>
            <span className="font-semibold text-base text-crisp-dark">
              {gems.toLocaleString('fr-FR')}
            </span>
          </div>
        )}
        {points > 0 && (
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <span className="text-lg">⭐</span>
              <span className="text-sm text-crisp-gray-dark">Points</span>
            </div>
            <span className="font-semibold text-base text-crisp-dark">
              {points.toLocaleString('fr-FR')}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};
